export function generateLink(link: string): string {
  return link.match(/:\/\//i) ? link : `//${link}`;
}
